import { render, staticRenderFns } from "./wxShare.vue?vue&type=template&id=6849d7b8&"
import script from "./wxShare.vue?vue&type=script&lang=js&"
export * from "./wxShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports